import { combineReducers } from "redux";
import exchangeRate from "./exchangeRate";

const configurationReducer = combineReducers({
    exchangeRate
});

export default configurationReducer;